module.exports = __webpack_public_path__ + "static/img/返回.017ec62.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/返回.png
// module id = 46
// module chunks = 382